export const CLASSES = {
	// Title
	title: "self-center underline font-bold text-3xl text-gray-300 hover:text-blue-300",

	// Background
	background: "bg-gray-800 h-screen",
	background2: "bg-gray-800 flex flex-col",

	// Sections
	section: "border-black p-1 my-1 w-full bg-blue-700",
	gridSection: "grid grid-cols-2 gap-2",
	gridSection3cols: "grid grid-cols-3 gap-2",
	gridSection12cols: "grid grid-cols-12 gap-2 my-1",

	// HTML Elements
	checkboxElement: "h-full w-6 place-self-center bg-red-500",
	radioButtonElement: "h-full w-6 h-6 place-self-center",
	labelElement: "w-full text-white my-auto",
	inputTextElement: "border-2 border-gray-600 w-full bg-blue-900 text-white text-center",
	blueprintStringTextElement: "border-2 border-gray-600 w-full my-1 bg-blue-900 text-white text-center",
	selectElement: "border-2 border-gray-600 w-full bg-blue-900 text-white",
	buttonElement: "border-2 border-gray-600 m-auto px-4 py-1 my-1 text-white rounded hover:bg-blue-300",
	// Styling doesnt apply for firefox, but works in chrome
	optionElement: "",
	footerElements: "text-center text-gray-500 hover:bg-gray-300 rounded m-auto px-2 my-1",
	// Error message field
	errorMessageElement: "text-center text-red-500 text-2xl m-1 p-2 border-2 border-red-500 bg-blue-800",
	// Warning message field
	warningMessageElement: "text-center text-yellow-500 text-xl m-1 px-2 bg-blue-800",
}
